import { http } from '@/lib/http';
import type { ReviewItem, ReviewResolution } from './types';

export async function listReviewQueue(): Promise<ReviewItem[]> {
  return http.get('v1/manual-review').json<ReviewItem[]>();
}

export async function resolveReview(
  reviewUrn: string,
  resolution: ReviewResolution,
): Promise<void> {
  await http.post(`v1/manual-review/${encodeURIComponent(reviewUrn)}/resolve`, {
    json: resolution,
  });
}
